import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiMenu, FiUser, FiX } from "react-icons/fi";

const navItems = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about-us" },
  { label: "Instant Filing", href: "/instant-filing" },
  { label: "Trademark", href: "/trademark" },
  { label: "Design", href: "/design" },
  { label: "Patent", href: "/patent" },
];

export default function LandingHeader() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="relative z-10 w-full pt-6 text-white">
      <div className="flex items-center justify-between px-6">
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="flex h-10 w-10 items-center justify-center md:hidden"
          aria-label="Toggle menu"
        >
          {menuOpen ? <FiX size={22} /> : <FiMenu size={22} />}
        </button>
        <div className="hidden w-10 md:block" />

        <Link
          to="/home"
          aria-label="Go to dashboard"
          className="border border-white px-8 py-3 text-center"
        >
          <div className="text-lg font-semibold tracking-wide">
            THE XPRESS IP COMPANY
          </div>
          <div className="text-xs tracking-widest text-slate-300">
            INSTANT IP FILING
          </div>
        </Link>

        <button
          onClick={() => navigate("/login")}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-white hover:bg-white/10"
        >
          <FiUser size={18} />
        </button>
      </div>

      <nav className="mt-10 hidden flex-wrap justify-center gap-8 px-6 text-sm tracking-wide md:flex md:gap-16">
        {navItems.map((item) => (
          <Link key={item.label} to={item.href} className="hover:text-white/70">
            {item.label.toUpperCase()}
          </Link>
        ))}
      </nav>

      <nav
        className={`flex flex-col items-center overflow-hidden text-sm tracking-wide transition-all duration-300 ease-out md:hidden ${
          menuOpen
            ? "max-h-96 gap-6 px-6 pb-6 pt-6 opacity-100"
            : "max-h-0 gap-0 px-6 opacity-0"
        }`}
      >
        {navItems.map((item) => (
          <Link
            key={item.label}
            to={item.href}
            onClick={() => setMenuOpen(false)}
            className="hover:text-white/70"
          >
            {item.label.toUpperCase()}
          </Link>
        ))}
      </nav>
    </div>
  );
}
